export default {"src":"/_next/static/media/stats-rosette.9fa22e30.svg","height":143,"width":198,"blurWidth":0,"blurHeight":0};